import PropTypes from "prop-types";
import "./Stepper.css";

export default function StepperPresets({ presets, onChange, label }) {
	return (
		<div
			className="stepper-presets"
			role="group"
			aria-label={`Preset values for ${label}`}
		>
			{presets.map((preset, index) => (
				<button
					type="button"
					key={index}
					onClick={() => onChange(preset)}
					aria-label={preset}
				>
					{preset}
				</button>
			))}
		</div>
	);
}

StepperPresets.propTypes = {
	presets: PropTypes.arrayOf(PropTypes.number).isRequired,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
};
